const GROUP_ORDER_EVENTS = [
  'item_added',
  'items_removed',
  'item_updated',
  'guest_joined',
  'guest_left',
  'guest_updated',
  'cart_updated'
];

export default GROUP_ORDER_EVENTS;
